import axios from 'axios';
import { getToken } from '../Utils/common';
import { SERVER_URL } from '../Utils/config';
const baseURL = SERVER_URL;

const handleErrors = (error) => {
  //TODO implement logic to handle/record errors
  console.log('error?.response?data', error?.response?.data);
  return [true, error?.response?.data || error];
};

const headerAutorization = () => {
  const token = getToken();
  if (token) {
    const header = {
      Authorization: `Bearer ${token}`,
    };
    return header;
  } else {
    return false;
  }
};

export const get = async (url, params = {}, headers = {}) => {
  const authorization = headerAutorization();
  if (authorization) {
    headers = { ...headers, ...authorization };
  }
  try {
    const result = await axios.get(baseURL + url, {
      params: params,
      headers: {
        ...headers,
      },
    });
    return [false, result?.data];
  } catch (e) {
    return handleErrors(e);
  }
};

export const post = async (url, body = {}, headers = {}) => {
  const authorization = headerAutorization();
  if (authorization) {
    headers = { ...headers, ...authorization };
  }
  try {
    const result = await axios.post(baseURL + url, body, headers);
    return [false, result?.data];
  } catch (e) {
    return handleErrors(e);
  }
};

export const put = async (url, body = {}, headers = {}) => {
  const authorization = headerAutorization();
  if (authorization) {
    headers = { ...headers, ...authorization };
  }
  try {
    const result = await axios.put(baseURL + url, body, headers);
    return [false, result?.data];
  } catch (e) {
    return handleErrors(e);
  }
};

export const patch = async (url, body = {}, headers = {}) => {
  const authorization = headerAutorization();
  if (authorization) {
    headers = { ...headers, ...authorization };
  }
  try {
    const result = await axios.patch(baseURL + url, body, headers);
    return [false, result?.data];
  } catch (e) {
    return handleErrors(e);
  }
};

export const deletes = async (url, params = {}, body = {}, headers = {}) => {
  const authorization = headerAutorization();
  if (authorization) {
    headers = { ...headers, ...authorization };
  }
  try {
    const result = await axios.delete(baseURL + url, {
      params: params,
      body: body,
      headers: {
        ...headers,
      },
    });
    return [false, result?.data];
  } catch (e) {
    return handleErrors(e);
  }
};
